import { createFileRoute } from '@tanstack/react-router'
import DocumentosDigitaisGerarPage from '@/pages/dashboard/documentos-digitais-gerar-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/novo',
)({
  component: DocumentosDigitaisGerarPage,
})
